module.exports = "./../fonts/fa-regular-400.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/fa-regular-400.woff2
// module id = 16
// module chunks = 0